<div [ngClass]=" toggleSidebar ? 'layout-content-spread':'layout-content-contract'">
      <div class="sidebar">
            <ng-content select="[leftSidebar]"></ng-content>
      </div>
      <div class="content">
            <ng-content select="[mainContent]"></ng-content>
      </div>
</div>